import gql from 'graphql-tag';

import agentLogRowFragment from '../fragments/agentLogRowFragment';

export default gql`
  query assistantTurns($count: Int!) {
    assistantTurns(count: $count) {
      id
      assistantTurnOrigin
      agentLogRows {
        ...agentLogRowFragment
      }
    }
  }
  ${agentLogRowFragment}
`;
